import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { setSelectedSubscriber } from '../../SelfCareSlice';
import { connect } from 'react-redux';
import { internalPage } from '../../Constant';
import { UpdateSubscriberName } from '../../Utilities';
const CellularSubscriber = ({ subscriber, isAbroad, showAirplane, selectedSubscriber, setSelectedSubscriber, goToPage, loginData, links }) => {
  const tempName = subscriber.productFirstName ? subscriber.productFirstName + ' ' + subscriber.productLastName : (isAbroad ? 'מנוי' : 'מה שם המנוי?');
  const canUpdateName = !(subscriber.productSubscriberNo == loginData?.userDetails?.contactNumber && (loginData.isFullAuthenticated || loginData.isOtpExtendedAuthenticated));
  return (
    <>
      {!isAbroad
        ? (<div className={`name`}>
          <span className='text'>{tempName}</span>{' '}
          {canUpdateName &&
            <Image className='edit-icon'
              onClick={(e) => {
                if (subscriber.productSubscriberNo == selectedSubscriber.productSubscriberNo) {
                  e.stopPropagation();
                  UpdateSubscriberName(subscriber, loginData, links);
                }
              }}
              src={require('./icon/edit.svg')}
              alt='edit' />}
        </div>)
        : (<div className={`name ${showAirplane ? 'text-img-wrapper' : ''}`}>
          <span className='text'>{tempName}</span>{' '}
          {showAirplane && <Image className='airplane-img'
            src={require('./icon/airplane.svg')}
            alt='airplane' />}
        </div>)
      }
      <span className='text number'>{subscriber.productSubscriberNo}</span>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    worldType: state.selfcarePage.epiData.worldType,
    subscribersByProduct: state.selfcarePage.subscribersByProduct,
    selectedSubscriber: state.selfcarePage.selectedSubscriber,
    loginData: state.authentication.loginData,
    links: state.selfcarePage.links,
  };
};

const mapDispatchToProps = { setSelectedSubscriber };

export default connect(mapStateToProps, mapDispatchToProps)(CellularSubscriber);
